import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { set } from "react-hook-form";


/**
 * @author noone
 */

export type ParameterState = {
    linkuid: string | null,
    listAuftragWithStatus: string,
    googleToken: string | null,
}

const initialState = {
    linkuid: null,
    listAuftragWithStatus: "NEU",
    googleToken: null,
} as ParameterState;

const allParameterSlice = createSlice({
    name: 'allParameter',
    initialState: initialState,
    reducers: {
        setLinkuid(state, action: PayloadAction<string>) {
            state.linkuid = action.payload;
        },
        setListAuftragWithStatus(state, action: PayloadAction<string>){
            state.listAuftragWithStatus = action.payload;
        },
        setGoogleToken(state, action: PayloadAction<string>){
            state.googleToken = action.payload;
        }
    }
});

export const {

    setLinkuid,
    setListAuftragWithStatus,
    setGoogleToken

} = allParameterSlice.actions;

export default allParameterSlice;


